(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestselling-backpack"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const thumbSwiper = new Swiper(".bbp-thumb-swiper", {
    spaceBetween: 12,
    slidesPerView: 5,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: {
      0: {
        direction: "horizontal",
        spaceBetween: 12,
        slidesPerView: 2.8,
      },
      768: {
        direction: "vertical",
        spaceBetween: 12,
        slidesPerView: 5,
      },
    },
  });

  new Swiper(".bbp-main-swiper", {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbSwiper,
    },
  });

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-feature-collection"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.collection-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const c = tab.dataset.collection;

    // switch active tab
    document.querySelectorAll('.collection-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    // switch sliders
    document.querySelectorAll('.tab-slider').forEach(slider => {
      slider.classList.toggle('active', slider.dataset.collection === c);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.review-card-slider', {
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 12,
      autoHeight: true,
      loop: true,
      navigation: {
        nextEl: '.review-button-next',
        prevEl: '.review-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 1.2,
          centeredSlides: true,
          spaceBetween: 16,
        },
        991: {
          slidesPerView: 1.5,
          centeredSlides: true,
          spaceBetween: 16,
        },
        1300: {
          slidesPerView: 2.4,
          centeredSlides: true,
          spaceBetween: 16,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romfre-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.romfre-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: false,
      centeredSlides: false,
      navigation: {
        nextEl: '.romfre-next',
        prevEl: '.romfre-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
